import { useState } from "react";

const facilities = [
  { name: "Fayetteville Main Post Office", address: "915 E Township St, Fayetteville, AR 72703", phone: "(479) 442-9234", hours: "Mon–Fri 9:00 AM – 4:00 PM", wait: "20–45 min" },
  { name: "Washington County Courthouse", address: "280 N College Ave, Fayetteville, AR 72701", phone: "(479) 444-1506", hours: "Mon–Fri 8:00 AM – 4:30 PM", wait: "15–30 min" },
  { name: "Springdale Post Office", address: "703 W Emma Ave, Springdale, AR 72764", phone: "(479) 756-3161", hours: "Mon–Fri 9:00 AM – 4:00 PM", wait: "15–25 min" },
];

export default function FayettevilleARAcceptanceFacilitiesSection() {
  const [open, setOpen] = useState<number | null>(0);
  return (
    <section id="facilities" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Acceptance Facilities</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Passport Acceptance Facilities Near Fayetteville, AR</h2>
        </div>
        <div className="space-y-4 max-w-3xl mx-auto">
          {facilities.map((f, i) => (
            <div key={i} className="border border-gray-200 rounded-lg bg-white overflow-hidden">
              <button onClick={() => setOpen(open === i ? null : i)} className="w-full flex items-center justify-between p-5 text-left">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8]"><i className="ri-map-pin-line text-[#1A365D]"></i></div>
                  <div><h3 className="font-bold text-[#1A365D] text-base">{f.name}</h3><p className="text-gray-400 text-xs">{f.address}</p></div>
                </div>
                <i className={`${open === i ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} text-gray-400 text-xl`}></i>
              </button>
              {open === i && (
                <div className="px-5 pb-5 pt-0 border-t border-gray-100">
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-4">
                    <div className="bg-[#F7F8FA] rounded-lg p-3"><p className="text-gray-400 text-xs mb-1">Phone</p><p className="text-[#1A365D] text-sm font-medium">{f.phone}</p></div>
                    <div className="bg-[#F7F8FA] rounded-lg p-3"><p className="text-gray-400 text-xs mb-1">Hours</p><p className="text-[#1A365D] text-sm font-medium">{f.hours}</p></div>
                    <div className="bg-[#F7F8FA] rounded-lg p-3"><p className="text-gray-400 text-xs mb-1">Avg Wait</p><p className="text-[#1A365D] text-sm font-medium">{f.wait}</p></div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}